"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.useTraffic = useTraffic;
var _react = require("react");
var _util = require("@ux/util");
/* eslint no-undef: 0 */

const traffic2 = {
  /**
   * Initialize traffic2.
   *
   * @param {Object} opts options object
   * @param {String} [opts.type=onload] type of initialization. values `disable`, `inline`, `onload`
   * @param {Boolean} [opts.beacon=true] whether to call beacon
   *
   * @private
   */
  init: function init(opts) {
    if (opts.type === 'disable') {
      return;
    }
    if (opts.type !== 'inline') {
      this.inject();
    }
    if (opts.beacon !== false) {
      this.beacon();
    }
  },
  /**
   * If there is a "ux" global (i.e. in the browser), then configure GTM immediately
   * with some values from ux.eldorado.data.props.
   *
   * @private
   */
  inject: function inject() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (typeof ux !== 'undefined' && typeof window !== 'undefined') {
      const data = ux.eldorado && ux.eldorado.data || {};
      const {
        shopperId,
        privateLabelId
      } = data.props || {};

      // When react-trfq was ejected, functionality was copied in to maintain compatible behaviors.
      // @see https://godaddy.slack.com/archives/C0J9L0JKS/p1656014870881749
      // @see https://github.secureserver.net/react/react-trfq/blob/master/index.js#L93-L115
      const w = window;
      w._gaDataLayer = w._gaDataLayer || [];
      shopperId && w._gaDataLayer.push({
        shopperId: shopperId
      });
      privateLabelId && w._gaDataLayer.push({
        privateLabelId: privateLabelId
      });
      w._gaDataLayer.push({
        'tcc.status': 'on'
      });
      w._gaDataLayer.push({
        'tcc.gastatus': 'off'
      });
      w._gaDataLayer = w._gaDataLayer.concat(w.ux && w.ux.gaconfig || []);
      w._gaq = w._gaq || [];
      if (options.domain) {
        w._gaq.push(['_setDomainName', options.domain]);
      }
      if (w.ux && w.ux.disable && w.ux.disable.ga === true) {
        return;
      } // eslint-disable-line no-undef
    }
  },
  /**
   * Logs a Traffic2 "beacon" event for the UX Platform team. This allows us to
   * get a gestalt for the total usage of all headers by all teams to better plan
   * new features and make prioritization features based on usage data.
   *
   * @private
   */
  beacon: function beacon() {
    if (typeof ux !== 'undefined' && typeof window !== 'undefined') {
      const url = new _util.URL(window.location.href, true);
      const data = ux.eldorado && ux.eldorado.data || {};
      const {
        app,
        split,
        manifest,
        market,
        countryName,
        languageName,
        currency
      } = data.props || {};

      // UXCore 1 pages do not load ux.versions onto the page,
      // so we use ux.version's existence as a proxy for
      // "Is this page uxcore 1"?
      const uxcore = ux.versions ? 2 : 1;
      if (manifest && app) {
        const query = (() => {
          try {
            return JSON.stringify(url.query);
          } catch (err) {
            return '{}';
          }
        })();

        // During server-rendering, we don't want to access `window`
        if (typeof window === 'undefined') return;
        const _expDataLayer = window._expDataLayer = window._expDataLayer || [];
        _expDataLayer.push({
          schema: 'add_event',
          version: 'v2',
          data: {
            eid: `uxp.hyd.int.${manifest.toLowerCase()}.${app.replace('.', '_')}.impression`.replace(/-/g, '_'),
            type: 'impression',
            custom_properties: {
              market,
              split,
              uxcore,
              currency,
              hostname: url.hostname,
              path: url.path,
              query,
              country: countryName,
              lang: languageName
            }
          }
        });
      }
    }
  }
};

/**
 * Initialize traffic
 *
 * @param {String} type Type of initialization
 * @param {Object} options Options
 * @param {Boolean} [opt.beacon=true] Init with traffic2 UXP beacon
 * @param {Boolean} [opt.initTraffic=true] Initialize traffic2?
 * @public
 */
exports.default = traffic2;
function useTraffic(type) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof options !== 'object') {
    // for backwards compatibility with previous signature of useTraffic(type, beacon)
    options = {
      beacon: Boolean(options)
    };
  }
  const {
    beacon = true,
    initTraffic = true
  } = options;
  (0, _react.useEffect)(() => {
    if (initTraffic) {
      traffic2.init({
        type,
        beacon
      });
    }
  }, [initTraffic, type, beacon]);
}